export function formatCurrency(value) {
  return `${Number(value || 0).toLocaleString("vi-VN")} ₫`;
}

export function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** "2026-07" -> "Tháng 07/2026" */
export function formatMonthLabel(yearMonth) {
  if (!yearMonth) return "—";
  const [year, month] = String(yearMonth).split("-");
  if (!year || !month) return yearMonth;
  return `Tháng ${month}/${year}`;
}

export function formatWorkDays(value) {
  return Number(value || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 });
}

export function formatOvertimeHours(minutes) {
  const hours = Number(minutes || 0) / 60;
  return `${hours.toLocaleString("vi-VN", { maximumFractionDigits: 2 })} giờ`;
}
